import React, { createContext, useContext, useState, useCallback } from 'react';

const PoliciesSelectContext = createContext(undefined);

export const PoliciesSelectProvider = ({ children }) => {
	const [selectedPolicies, setSelectedPolicies] = useState([]);
	const [touched, setTouched] = useState(false);

	const clearSelectedPolicies = useCallback(() => {
		setSelectedPolicies([]);
	}, []);

	const setPolicies = useCallback((policies) => {
		setSelectedPolicies((prev) => {
			if (JSON.stringify(policies) === JSON.stringify(prev)) {
				return prev;
			}
			return policies;
		});
		setTouched(true);
	}, []);

	const value = {
		selectedPolicies,
		setSelectedPolicies: setPolicies,
		clearSelectedPolicies,
		touched,
		setTouched,
	};

	return (
		<PoliciesSelectContext.Provider value={value}>{children}</PoliciesSelectContext.Provider>
	);
};

export const usePoliciesSelect = () => {
	const context = useContext(PoliciesSelectContext);
	if (!context) {
		throw new Error('usePoliciesSelect must be used within a PoliciesSelectProvider');
	}

	return context;
};
